import React, { useContext } from "react";

import FormErrorNotification from "../../../Components/Forms/FormErrorNotification";
import OptionalFormRow from "../../../Components/HorizontalForm/OptionalFormRow";
import CharacterCounter from "../../../Components/Inputs/CharacterCounter";
import BookingFormVisitors from "./Sections/BookingFormVisitors";
import HtmlForm from "../../FormLogs/Components/HtmlForm";
import { BookingFormContext } from "./BookingFormProvider";
import BookingFormPaymentSection from "./Sections/BookingFormPaymentSection";
import BookingFormSubmitSection from "./Sections/BookingFormSubmitSection";
import BookingFormTimeSection from "./Sections/BookingFormTimeSection";
import BookingFormTimeSectionDisabled from "./Sections/BookingFormTimeSectionDisabled";
import BookingFormUserSection from "./Sections/BookingFormUserSection";

const BookingForm = (props) => {

    const {
        editBookingId,

        date,
        category,
        amenity,
        booking,
        errors,

        bookingConfig,

        onBookingFormChange,
        onBookingFormChangeEvent,
    } = useContext(BookingFormContext);

    if (!booking.unit_id || !category || !amenity || !bookingConfig) {
        return null;
    }

    return (
        <form>
            <FormErrorNotification errors={errors}/>

            {(booking.payment?.id) &&
                <div className="section form-container full">
                    <p className="margin-bottom-2 color-error">
                        Once a payment has been made, bookings at chargeable amenities cannot be rescheduled.
                        You may cancel and re-book, however refund eligibility is stated under the terms & conditions.
                    </p>
                </div>
            }

            <BookingFormUserSection/>

            {(!booking.payment?.id || !booking.payment?.attempted_at)
                ? <BookingFormTimeSection/>
                : <BookingFormTimeSectionDisabled/>
            }

            <section className="section form-container full">
                <OptionalFormRow
                    label="Notes for Staff"
                    value={booking.notes}
                    onHide={() => onBookingFormChange('notes', '')}
                    errorMessage={errors.notes}
                    collapsible
                >
                    <CharacterCounter
                        max={255}
                        value={booking.notes}
                        onChange={onBookingFormChangeEvent}
                        errorMessage={errors.notes}
                    >
                        <textarea
                            name="notes"
                            value={booking.notes}
                            onChange={onBookingFormChangeEvent}
                            rows={4}
                            style={{ resize: 'none' }}
                        />
                    </CharacterCounter>
                </OptionalFormRow>

                {bookingConfig.form &&
                    <HtmlForm
                        form={bookingConfig.form}
                        fields={bookingConfig.form.fields}
                        onChange={(values) => onBookingFormChange('form', values)}
                        errors={errors}
                        values={booking.form}
                    />
                }
            </section>

            <BookingFormVisitors
                bookingConfig={bookingConfig}
                values={booking}
                errors={errors}
                onChange={onBookingFormChange}
            />

                {(bookingConfig.payment_enabled && !editBookingId)
                    ? <BookingFormPaymentSection/>
                    : <BookingFormSubmitSection onCancel={props.onCancel}/>
                }
        </form>
    )
}

BookingForm.defaultProps = {};

export default BookingForm;
